export const updatePackages = (state, packages) => {
  state.packages = packages;
};

export const updateHomeCategories = (state, categories) => {
  state.home.categories = categories;
};

export const updateHomeCarousel = (state, carousel) => {
  state.home.carousel = carousel;
};
export const updateMovilCarousel = (state, carousel) => {
  state.carouselMovil = carousel;
};
export const updateUser = (state, user) => {
  state.user = user;
};
export const updateUserAdmin = (state, userAdmin) => {
  state.userAdmin = userAdmin;
};

export const updateNews = (state, news) => {
  state.news = news;
};
export const updateNewCategories = (state, newCategories) => {
  state.newCategories = newCategories;
};
export const updateContact = (state, contact) => {
  state.contact = contact;
};

export const updateAboutSections = (state, sections) => {
  state.about.sections = sections;
};

export const updateRequests = (state, requests) => {
  state.requests = requests;
};
export const updateUsers = (state, users) => {
  state.users = users;
};

export const clearAll = (state) => {
  state.packages = [];
};
export const clearUser = (state) => {
  state.user = null;
  state.userAdmin=null;
  state.news=[];
  state.packages=[];
  state.requests=[];
  state.carouselMovil=[]
  state.users=[]
};
